import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import DatePicker from 'react-datepicker';

import classes from './timesheetFilters.module.css';

import 'react-datepicker/dist/react-datepicker-min.module.css';

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
  startDate: any;
  endDate: any;
  employeeFilters: any[];
  selectedEmployeeId: string;
  projectNumberFilters: any[];
  selectedProjectId: string;
  onEmployeeChange: (e: any) => void;
  onProjectChange: (e: any) => void;
  onChangeDate: (dates: any) => void;
  onClearDate: () => void;
}

function TimesheetFilters({
  containerRef,
  startDate,
  endDate,
  employeeFilters,
  selectedEmployeeId,
  projectNumberFilters,
  selectedProjectId,
  onEmployeeChange,
  onProjectChange,
  onChangeDate,
  onClearDate,
}: Props) {
  return (
    <div ref={containerRef} className={classes.container}>
      <div className={classes.filterRow}>
        <div className={classes.filterGroup}>
          <span className={classes.filterLabel}>SINCE</span>
          <div className={classes.dateWrapper}>
            <DatePicker
              selected={startDate}
              onChange={onChangeDate}
              startDate={startDate}
              endDate={endDate}
              maxDate={new Date()}
              selectsRange
              dateFormat="yyyy - MM - dd"
              className={classes.dateInput}
              placeholderText="Select date range..."
            />
            {startDate && (
              <button type="button" className={classes.clearDateButton} onClick={onClearDate} title="Clear dates">
                &times;
              </button>
            )}
          </div>
        </div>
        <div className={classes.filterGroup}>
          <span className={classes.filterLabel}>PROJECT</span>
          <select className={classes.selectInput} value={selectedProjectId} onChange={onProjectChange}>
            <option value="">All Projects</option>
            {projectNumberFilters?.map((p: any) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>
        <div className={classes.filterGroup}>
          <span className={classes.filterLabel}>EMPLOYEE</span>
          <select className={classes.selectInput} value={selectedEmployeeId} onChange={onEmployeeChange}>
            <option value="">All Employees</option>
            {employeeFilters?.map((e: any) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

const TimesheetFiltersMemo = memo(TimesheetFilters, areEqual);

export { TimesheetFiltersMemo as TimesheetFilters };
